import { render } from "./TeacherAskingDialog.vue?vue&type=template&id=6a2e541e&scoped=true"
import script from "./TeacherAskingDialog.vue?vue&type=script&lang=js"
export * from "./TeacherAskingDialog.vue?vue&type=script&lang=js"

import "./TeacherAskingDialog.vue?vue&type=style&index=0&id=6a2e541e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2e541e"]])

export default __exports__